export default "__VITE_ASSET__Bdn9gxOm__"